import React, { useState, memo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Input } from 'antd'
import { UseIntentBargain } from '../intent-modal/bargain'
import { getYearMonth, isNumberInput } from '$utils'
import './index.scss'

const { Search } = Input

const CarBargain = ({ carInfo }) => {
  const city = useSelector(store => store.city)
  const { fr, ino } = city
  const { phone } = useSelector(store => store.user)
  const {
    title, tags, mileage, emission, price, sold
  } = carInfo
  const [priceTo, setPriceTo] = useState()
  return (
    <>
      <div
        className="r-detail-middle-bargain clearfix"
        data-exposure="car-detail_cutpricebanner_display"
      >
        <div className="r-detail-middle-bargain__car-info">
          <h1>{title}</h1>
          <ul>
            <li className="info">{getYearMonth(carInfo.licensed_date)}</li>
            <li className="info">{Number(mileage).toFixed(2)}万公里</li>
            <li className="info">{emission}</li>
            <li className="info">{carInfo.licensed_city}</li>
            {/* 最多显示10个标签 */}
            {tags && tags.slice(0, 10).map(tag => (
              <li
                className="tag"
                key={tag.txt}
                style={{ backgroundColor: tag.color }}
              >
                {tag.txt}
              </li>
            ))}
          </ul>
        </div>
        <div className="r-detail-middle-bargain__bargain-area clearfix">
          {/* 砍价 */}
          {sold !== true && (
            <Search
              className="cut"
              placeholder="输入您的意向价"
              enterButton="砍价"
              size="large"
              value={priceTo}
              onClick={() => { global.$rbl.push('car-detail_cutpricebanner-phoneinput_click') }}
              onInput={(e) => {
                if (isNumberInput(e.target.value)) {
                  setPriceTo(e.target.value)
                }
              }}
              onSearch={(value) => {
                global.$rbl.push({
                  event: 'car-detail_cutpricebanner-submitbutton_click',
                  content: {
                    param: '砍价-PC-详情页-4'
                  }
                })
                const submitParams = {
                  phone: phone || '',
                  source: `${fr}${ino ? '_异地' : ''}`,
                  owner_price: `${price}`,
                  price: `${value}`,
                  submit_sources: '砍价-PC-详情页-4'
                }
                const otherParams = { ino, basicInfo: carInfo }
                new UseIntentBargain({ submitParams, otherParams }).open()
              }}
            />
          ) }

          <div className="buy">
            <p className="buy-price">卖家报价：<span>￥{Number(price).toFixed(2)}万</span></p>
            {sold !== true && <p className="buy-subscript">对车价不满意？</p>}
          </div>
        </div>
      </div>
    </>
  )
}

export default memo(CarBargain)

CarBargain.propTypes = {
  carInfo: PropTypes.object
}

CarBargain.defaultProps = {
  carInfo: {
    title: '',
    licensed_date: '',
    mileage: 0,
    emission: '',
    licensed_city: '',
    tags: [],
    sold: false
  }
}
